import { render } from "./TaskCaption.vue?vue&type=template&id=5f28d859"
import script from "./TaskCaption.vue?vue&type=script&lang=js"
export * from "./TaskCaption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__